import { render, staticRenderFns } from "./UpdateRatePlanForm.vue?vue&type=template&id=9388ed84&scoped=true&"
import script from "./UpdateRatePlanForm.vue?vue&type=script&lang=js&"
export * from "./UpdateRatePlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9388ed84",
  null
  
)

export default component.exports